export default __webpack_public_path__ + "static/general_healthcare_w.fa2663c5f7c47d8aa55b476bbbfeb719.png";